import type { ComponentType } from 'react';
import type { CandidateRouteKey } from 'candidate-url-registry';
import { lazyWithReload } from 'utils/lazyWithReload';

import type { CandidateLazyMount } from './types';

export interface CandidateRouteAdapter {
  matches: () => boolean;
  load: CandidateLazyMount['load'];
}
const adapters = new Map<CandidateRouteKey, CandidateRouteAdapter[]>();
const components = new WeakMap<CandidateRouteAdapter, ComponentType>();

export function registerCandidateRouteAdapter(
  key: CandidateRouteKey,
  adapter: CandidateRouteAdapter
): void {
  adapters.set(key, [...(adapters.get(key) ?? []), adapter]);
}

export function adaptCandidateRoute(
  key: CandidateRouteKey,
  DefaultComponent: ComponentType
): ComponentType {
  return function CandidateRoute() {
    const adapter = adapters.get(key)?.find((entry) => entry.matches());
    if (!adapter) return <DefaultComponent />;
    let Component = components.get(adapter);
    if (!Component) {
      Component = lazyWithReload(adapter.load);
      components.set(adapter, Component);
    }
    return <Component />;
  };
}
